import { useEffect, useState } from 'react';
import { useUserContext } from '../contexts/user';
import useLocalStorage from './useLocalStorage';

export const usePersistentUserLocalStorage = (key, initialValue) => {
  const { userSession } = useUserContext();
  const [clientId, setClientId] = useState(userSession?.clientId);
  const userId = userSession?.userId || 'default';

  const [storedValue, setStoredValue] = useLocalStorage(key, {
    [userId]: initialValue,
  });

  const setValue = (value) => {
    setStoredValue((oldValue) => {
      const valueToStore = value instanceof Function ? value(oldValue[userId]) : value;

      return {
        ...oldValue,
        [userId]: valueToStore,
      };
    });
  };

  const resetValue = () => {
    setStoredValue((oldValue) => ({
      ...oldValue,
      [userId]: initialValue,
    }));
  };

  useEffect(() => {
    if (clientId === undefined) {
      setClientId(userSession?.clientId);
    } else if (clientId !== userSession?.clientId) {
      setClientId(userSession?.clientId);
      resetValue();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userSession?.clientId]);

  return [storedValue[userId] ?? initialValue, setValue];
};
